var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMergeToGrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 876,
    zoomAndPan: "magnify",
    viewBox: "0 0 657 505.49999",
    height: 674,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c4114dfcb0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.3125 5 L 404 5 L 404 494.929688 L 5.3125 494.929688 Z M 5.3125 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82d0958bfe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.289062 80.390625 C 53.453125 121.929688 39.207031 170.191406 39.207031 221.628906 C 39.207031 326.757812 98.65625 418.605469 186.539062 466.949219 L 167.21875 494.441406 C 142.902344 480.773438 120.277344 463.910156 99.894531 444.050781 C 38.917969 384.640625 5.320312 305.648438 5.320312 221.628906 C 5.320312 161.320312 22.632812 103.617188 54.941406 53.867188 C 57.628906 49.75 60.214844 45.296875 62.871094 40.828125 L 62.832031 40.789062 L 82.511719 7.09375 C 82.511719 5.703125 84.230469 4.996094 85.21875 5.984375 L 402.828125 351.273438 C 403.105469 351.601562 403.484375 351.773438 403.925781 351.773438 L 347.371094 351.773438 L 105.039062 88.183594 L 86.539062 67.414062 C 83.671875 71.660156 80.914062 75.984375 78.289062 80.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d5e07afa75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 461.324219 12 L 651.914062 12 L 651.914062 499.917969 L 461.324219 499.917969 Z M 461.324219 12 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "010d3172d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 596.203125 45.925781 C 588.054688 34.15625 579.023438 22.878906 569.183594 12.167969 L 552.777344 28.582031 L 545.375 35.984375 C 552.757812 44.175781 559.671875 52.777344 566.054688 61.757812 C 568.121094 64.664062 570.140625 67.625 572.097656 70.609375 C 600.699219 114.277344 617.292969 166.09375 617.292969 221.628906 C 617.292969 330.011719 554.085938 424.289062 461.6875 471.324219 L 479.109375 499.914062 C 507.304688 485.378906 533.398438 466.648438 556.605469 444.0625 C 617.59375 384.648438 651.191406 305.65625 651.191406 221.640625 C 651.191406 158.105469 631.980469 97.433594 596.226562 45.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54edde8929"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 353.558594 9 L 597 9 L 597 258.441406 L 353.558594 258.441406 Z M 353.558594 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4e8c50296c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 589.042969 53.597656 L 583.335938 59.351562 L 385.042969 257.644531 C 384.375 258.3125 383.285156 258.3125 382.636719 257.644531 L 354.34375 229.371094 C 353.683594 228.703125 353.683594 227.613281 354.34375 226.945312 L 545.363281 35.984375 L 564.15625 15.246094 L 569.820312 9.070312 C 578.054688 20.808594 585.484375 28.292969 596.203125 45.925781 C 595.445312 45.792969 589.042969 53.597656 589.042969 53.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d4ee1f3cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247 328 L 536 328 L 536 370 L 247 370 Z M 247 328 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b8a6460410"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 535.324219 330.542969 L 525.914062 350.242188 C 522.859375 356.65625 519.269531 362.78125 515.285156 368.664062 L 513.148438 368.664062 L 514.59375 369.644531 L 431.9375 369.644531 L 400.519531 369.585938 L 289.269531 369.585938 C 288.808594 369.585938 288.398438 369.414062 288.109375 369.125 L 248.660156 329.671875 L 247.332031 328.34375 L 247.332031 328.226562 L 453.078125 328.226562 L 533.828125 328.164062 C 535.035156 328.164062 535.84375 329.433594 535.324219 330.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "83cbb5664d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99 149 L 515 149 L 515 462.996094 L 99 462.996094 Z M 99 149 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58bddb9d55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 514.585938 369.644531 C 497.3125 394.660156 472.1875 415.050781 446.484375 430.355469 C 411.078125 451.382812 370.527344 462.53125 329.121094 462.53125 C 267.660156 462.53125 209.847656 438.566406 166.410156 395.128906 C 122.972656 351.632812 99.007812 293.878906 99.007812 232.421875 C 99.007812 205.90625 105.132812 175.644531 114.082031 150.570312 C 114.480469 149.472656 115.929688 149.132812 116.800781 149.992188 L 143.421875 176.617188 C 143.882812 177.074219 144.0625 177.773438 143.832031 178.34375 C 136.269531 199.082031 135.980469 209.761719 135.980469 232.410156 C 135.980469 338.925781 222.625 425.558594 329.128906 425.558594 C 379.148438 425.558594 426.632812 406.039062 462.097656 372.480469 C 463.136719 371.503906 462.386719 369.652344 460.9375 369.652344 Z M 514.585938 369.644531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f266878f18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 15.964844 L 480 15.964844 L 480 99.785156 L 180 99.785156 Z M 180 15.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a241695b9e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 478.941406 75.085938 L 455.085938 98.933594 C 454.464844 99.550781 453.484375 99.582031 452.816406 99.011719 C 418.109375 69.191406 374.324219 52.917969 328.171875 52.917969 C 283.523438 52.917969 241.105469 68.140625 206.980469 96.105469 C 206.320312 96.644531 205.371094 96.605469 204.773438 96.003906 L 180.875 72.117188 C 180.195312 71.4375 180.238281 70.308594 180.976562 69.691406 C 222.125 34.925781 273.765625 15.984375 328.171875 15.984375 C 384.125 15.984375 437.152344 36.023438 478.859375 72.679688 C 479.582031 73.308594 479.609375 74.417969 478.929688 75.085938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "862b610d4e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.3125 5 L 404 5 L 404 494.929688 L 5.3125 494.929688 Z M 5.3125 5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "90fbb55210"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78.289062 80.390625 C 53.453125 121.929688 39.207031 170.191406 39.207031 221.628906 C 39.207031 326.757812 98.65625 418.605469 186.539062 466.949219 L 167.21875 494.441406 C 142.902344 480.773438 120.277344 463.910156 99.894531 444.050781 C 38.917969 384.640625 5.320312 305.648438 5.320312 221.628906 C 5.320312 161.320312 22.632812 103.617188 54.941406 53.867188 C 57.628906 49.75 60.214844 45.296875 62.871094 40.828125 L 62.832031 40.789062 L 82.511719 7.09375 C 82.511719 5.703125 84.230469 4.996094 85.21875 5.984375 L 402.828125 351.273438 C 403.105469 351.601562 403.484375 351.773438 403.925781 351.773438 L 347.371094 351.773438 L 105.039062 88.183594 L 86.539062 67.414062 C 83.671875 71.660156 80.914062 75.984375 78.289062 80.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38ef8292cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 461.324219 12 L 651.914062 12 L 651.914062 499.917969 L 461.324219 499.917969 Z M 461.324219 12 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2059d94889"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 596.203125 45.925781 C 588.054688 34.15625 579.023438 22.878906 569.183594 12.167969 L 552.777344 28.582031 L 545.375 35.984375 C 552.757812 44.175781 559.671875 52.777344 566.054688 61.757812 C 568.121094 64.664062 570.140625 67.625 572.097656 70.609375 C 600.699219 114.277344 617.292969 166.09375 617.292969 221.628906 C 617.292969 330.011719 554.085938 424.289062 461.6875 471.324219 L 479.109375 499.914062 C 507.304688 485.378906 533.398438 466.648438 556.605469 444.0625 C 617.59375 384.648438 651.191406 305.65625 651.191406 221.640625 C 651.191406 158.105469 631.980469 97.433594 596.226562 45.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "487b21f032"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 353.558594 9 L 597 9 L 597 258.441406 L 353.558594 258.441406 Z M 353.558594 9 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f059886644"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 589.042969 53.597656 L 583.335938 59.351562 L 385.042969 257.644531 C 384.375 258.3125 383.285156 258.3125 382.636719 257.644531 L 354.34375 229.371094 C 353.683594 228.703125 353.683594 227.613281 354.34375 226.945312 L 545.363281 35.984375 L 564.15625 15.246094 L 569.820312 9.070312 C 578.054688 20.808594 585.484375 28.292969 596.203125 45.925781 C 595.445312 45.792969 589.042969 53.597656 589.042969 53.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a4af7078d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 247 328 L 536 328 L 536 370 L 247 370 Z M 247 328 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "41ab8f67b5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 535.324219 330.542969 L 525.914062 350.242188 C 522.859375 356.65625 519.269531 362.78125 515.285156 368.664062 L 513.148438 368.664062 L 514.59375 369.644531 L 431.9375 369.644531 L 400.519531 369.585938 L 289.269531 369.585938 C 288.808594 369.585938 288.398438 369.414062 288.109375 369.125 L 248.660156 329.671875 L 247.332031 328.34375 L 247.332031 328.226562 L 453.078125 328.226562 L 533.828125 328.164062 C 535.035156 328.164062 535.84375 329.433594 535.324219 330.53125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b1243f8017"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 99 149 L 515 149 L 515 462.996094 L 99 462.996094 Z M 99 149 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "45858ea214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 514.585938 369.644531 C 497.3125 394.660156 472.1875 415.050781 446.484375 430.355469 C 411.078125 451.382812 370.527344 462.53125 329.121094 462.53125 C 267.660156 462.53125 209.847656 438.566406 166.410156 395.128906 C 122.972656 351.632812 99.007812 293.878906 99.007812 232.421875 C 99.007812 205.90625 105.132812 175.644531 114.082031 150.570312 C 114.480469 149.472656 115.929688 149.132812 116.800781 149.992188 L 143.421875 176.617188 C 143.882812 177.074219 144.0625 177.773438 143.832031 178.34375 C 136.269531 199.082031 135.980469 209.761719 135.980469 232.410156 C 135.980469 338.925781 222.625 425.558594 329.128906 425.558594 C 379.148438 425.558594 426.632812 406.039062 462.097656 372.480469 C 463.136719 371.503906 462.386719 369.652344 460.9375 369.652344 Z M 514.585938 369.644531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "911bc05214"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 15.964844 L 480 15.964844 L 480 99.785156 L 180 99.785156 Z M 180 15.964844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "605aeca5b7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 478.941406 75.085938 L 455.085938 98.933594 C 454.464844 99.550781 453.484375 99.582031 452.816406 99.011719 C 418.109375 69.191406 374.324219 52.917969 328.171875 52.917969 C 283.523438 52.917969 241.105469 68.140625 206.980469 96.105469 C 206.320312 96.644531 205.371094 96.605469 204.773438 96.003906 L 180.875 72.117188 C 180.195312 71.4375 180.238281 70.308594 180.976562 69.691406 C 222.125 34.925781 273.765625 15.984375 328.171875 15.984375 C 384.125 15.984375 437.152344 36.023438 478.859375 72.679688 C 479.582031 73.308594 479.609375 74.417969 478.929688 75.085938 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4114dfcb0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82d0958bfe)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e4937",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d5e07afa75)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#010d3172d1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e4937",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54edde8929)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4e8c50296c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#038c4c",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d4ee1f3cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b8a6460410)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#038c4c",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#83cbb5664d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58bddb9d55)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0e4937",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f266878f18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a241695b9e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#038c4c",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#862b610d4e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#90fbb55210)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38ef8292cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2059d94889)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#487b21f032)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f059886644)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a4af7078d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#41ab8f67b5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b1243f8017)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#45858ea214)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#911bc05214)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#605aeca5b7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0 L 655.90625 0 L 655.90625 504.90625 L 0.324219 504.90625 Z M 0.324219 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeToGrowWhite);
export default __webpack_public_path__ + "static/media/MergeToGrowWhite.12e6e0a6d8eac1060c34b1f8423ccc01.svg";
export { ForwardRef as ReactComponent };